import React, { useState, useMemo } from 'react';
import MaterialTable from 'material-table'
import { Fab, withStyles, Typography, IconButton, Tooltip } from '@material-ui/core';
import * as actions from './store/cpuActions';
import * as action from '../../np-core/Auth/store/authActions';
import { connect } from 'react-redux';
import { Add, Delete, Refresh } from '@material-ui/icons';
import CPUDelete from './CPUDelete'
import { hasPermission, localization, hasAtLeastOnePermission, getDimensionsOfPagination } from '../../sc-utilities';
import Toolbar from '../../sc-utilities/Toolbar'
import { CsvBuilder } from 'filefy';
import { MuiTableRows } from '../../../themes';

const styles = theme => ({
    "@global": {
        "[class*='buttonsCustomer']": {
            margin: theme.spacing(),
            fontSize: '13px',
            width: '100%',
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
                color: theme.palette.buttonText.default
            },
        },
        "[class*='paletteButtons']": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.buttonText.default,
            margin: theme.spacing(),
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
            },
        },
        "[class*='MuiTableCell-root MuiTableCell-body']": {
            height: "40px",
            padding: '2px',
            fontSize: '0.7rem'
        },
    },
    fab: {
        textTransform: "none",
        width: '50%',
        color: theme.palette.buttonText.default,
        marginLeft: theme.spacing(),
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        }
    },
    customToolbar: {
        marginTop: 15,
        marginLeft: 14,
        width: "900px"
    },
    tableTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'visible',
    },
    customTooltip: {
        marginLeft: -16,
        marginTop: '-2px'
    },
    toolbar: {
        paddingTop: '1%'
    }
});
let pageSize = 100;
let rowsPageSizeInit = [20, 50, 100];

const CPUList = props => {
    const { classes, handleOpen, translations, editable, saveColumnsFilter, onFetchCPUsCount, onBulkDeleteCPUs, activeCustomer, permissions, tableColumns, cpus, onFetchCPUs, tableRef } = props;
    const [deleteModalState, setDeleteModalState] = useState({ open: false, componentIDs: [] });

    const customExport = (columns, cpuComponentList) => {
        if (columns && columns[0].field === 'Action') {
            columns.shift()
        }
        const data = cpuComponentList.map(cpuComponent => {
            let returnObj = [
                cpuComponent.ComponentType ? cpuComponent.ComponentType : translations['short_not_assigned'] || 'n/a',
                cpuComponent.Vendor ? cpuComponent.Vendor : translations['short_not_assigned'] || 'n/a',
                cpuComponent.ComponentModel ? cpuComponent.ComponentModel : translations['short_not_assigned'] || 'n/a',
                cpuComponent.SerialNumber ? cpuComponent.SerialNumber : translations['short_not_assigned'] || 'n/a',
                cpuComponent.Description ? cpuComponent.Description : translations['short_not_assigned'] || 'n/a',
                cpuComponent.Deleted ? 'Yes' : 'No'
            ];
            return returnObj;
        });
        const builder = new CsvBuilder(`securaze_cpu_${Math.floor(Date.now() / 1000)}.csv`);
        builder
            .setDelimeter('|')
            .setColumns(columns.map(columnDef => columnDef.title))
            .addRows(data)
            .exportFile();
    };

    const fetching = cpus.fetching;
    const columnObject = useMemo(() => tableColumns
        // eslint-disable-next-line react-hooks/exhaustive-deps
        , []); const [tableOptions, setTableOptions] = useState({
            filtering: true,
            sorting: false,
            selection: hasAtLeastOnePermission(permissions, ["component_delete"]),
            search: false,
            minBodyHeight: window.innerHeight - 295 < 250 ? 250 : window.innerHeight - 295,
            maxBodyHeight: window.innerHeight - 295,
            pageSizeOptions: rowsPageSizeInit,

            exportCsv: customExport,
            exportButton: false,
            rowStyle: (_rowData, index) => {
                return { backgroundColor: index % 2 ? MuiTableRows.odd : MuiTableRows.even };
            }, columnsButton: true,
            pageSize: pageSize ? pageSize : 50,
            emptyRowsWhenPaging: false
        });

    const handleBulkDelete = componentIDS => {
        if (!componentIDS) {
            setDeleteModalState({ open: false, componentID: null, componentIDs: [], forBulk: false });
            return;
        }
        setDeleteModalState({ ...deleteModalState, open: true, componentIDs: componentIDS, forBulk: true });
    };

    const tableActions = [
        {
            tooltip: `${translations["remove_all_selected"] || "Remove All Selected "} ${translations["cpus"] || "cpus "}`,
            icon: <Delete />,
            onClick: (rowData) => handleBulkDelete(rowData.map(cpu => cpu.ComponentID)),
            position: 'toolbarOnSelect',
        }
    ]

    const filterQuery = filters => {
        let obj = {};
        for (var filter of filters) {
            obj[filter.column.field] = filter.value;
        }
        obj['ComponentType'] = 'cpu';
        obj['ProductID'] = props.productID;
        return obj;
    }
    async function fetchTableData(query) {
        let q = filterQuery(query.filters);

        query['ActiveCustomerID'] = activeCustomer;
        query['q'] = q;
        let count = await onFetchCPUsCount(query);
        if (!query['page'] && query['pageSize'] !== 20 && query['pageSize'] !== 100) {
            let dimensions = getDimensionsOfPagination(count)
            query['pageSize'] = dimensions.pageSize
            rowsPageSizeInit = dimensions.rowsPageSize
            pageSize = dimensions.pageSize
        }
        let result = count ? await onFetchCPUs(query) : [];
        setTableOptions({ ...tableOptions, pageSize: query['pageSize'], pageSizeOptions: rowsPageSizeInit });
        return { data: result, page: query.page, pageSize: pageSize, totalCount: count };
    }

    const columnHidden = newColumnState => {
        let objToSendColumn = {}
        let objColumns = {}
        columnObject.map(column => {
            objColumns[`${column.field}`] = column.hidden
            return objColumns
        })
        objToSendColumn[`CPU`] = objColumns
        saveColumnsFilter({ ...objToSendColumn, ActiveCustomerID: activeCustomer })
        return newColumnState
    }

    const handleCloseDanger = async () => {
        await onBulkDeleteCPUs({ ComponentIDs: deleteModalState.componentIDs, ActiveCustomerID: activeCustomer });
        handleBulkDelete();
        tableRef.current && tableRef.current.onQueryChange()
    }

    const tableTitle = () => {
        return <div className={classes.customToolbar}>
            <div className={classes.tableTitle}>
                <Typography className={classes.typography}>{translations["cpus"] || "CPUS"}</Typography>
                {hasPermission(permissions, "component_create") ? (
                    <Fab
                        variant="extended"
                        size="small"
                        color="primary"
                        aria-label="Add"
                        disabled={!editable}
                        style={{ borderRadius: '1px' }}
                        className={classes.fab}
                        onClick={handleOpen}
                    >
                        <Add size="small" />
                        {translations["create_new"] || "Create new"}
                    </Fab>
                ) : null}
                <Tooltip title={translations["refresh"] || "Refresh"}>
                    <IconButton aria-label={translations["refresh"] || "Refresh"} component="div" disabled={fetching} onClick={() => tableRef.current && tableRef.current.onQueryChange()}>
                        <Refresh />
                    </IconButton>
                </Tooltip>
            </div>
        </div>
    }
    return (<>
        <MaterialTable
            components={{
                Toolbar: props => (
                    <Toolbar data={props} classes={{ toolbar: classes.toolbar }} editable={!editable} actions={tableActions} selectedRows={props.selectedRows} translations={translations} />
                )
            }}
            tableRef={tableRef}
            title={tableTitle()}
            columns={columnObject}
            data={fetchTableData}
            options={tableOptions}
            isLoading={fetching}
            localization={localization(translations)}
            onChangeRowsPerPage={(size) => {
                pageSize = size
            }}
            onChangeColumnHidden={columnHidden}
            actions={tableActions}
            onChangePage={() => {if(tableRef?.current?.tableContainerDiv?.current) {tableRef.current.tableContainerDiv.current.scrollTop = 0}}}
        />
        {hasPermission(permissions, "component_delete") ? (
            <CPUDelete
                activeCustomer={activeCustomer}
                entityName={translations["cpus"] || "CPUS"}
                translations={translations}
                handleDelete={handleBulkDelete}
                handleCloseDanger={handleCloseDanger}
                deleteModalState={deleteModalState}
            />
        ) : null}

    </>)
}

const mapDispatchToProps = dispatch => {
    return {
        onFetchCPUsCount: filter => dispatch(actions.fetchCPUCount(filter)),
        onFetchCPUs: filter => dispatch(actions.fetchCPU(filter)),
        saveColumnsFilter: data => dispatch(action.saveColumnsFilter(data)),
        onBulkDeleteCPUs: cpu => dispatch(actions.bulkDeleteCPUs(cpu))
    };
};

const mapStateToProps = state => {
    return {
        permissions: state?.core?.login?.permissions || [],
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        cpus: state.product.cpus,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {}
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(CPUList));